module.exports = __webpack_public_path__ + "img/recruit-banner@2x.5c219a9e.png";